export default "__VITE_ASSET__027b7c92__"